import { HttpClient} from "@angular/common/http";
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';

import { environment } from '../../../environments/environment';

@Injectable()
export class ExternalCompanyPaymentService {

    constructor(private http: HttpClient) {}

    all(req){
        req.activeSort = req.activeSort || 'id';
        req.sortDirection = req.sortDirection || 'asc';
        req.page = req.page || 1; //default first page
        req.perPage = req.perPage || 5; //default no limit
        req.filter = req.filter || '';
        req.trash = req.trash || '';

        let requestUrl = environment.apiUrl + 'external-company/payments/all';
        requestUrl += "?page=" + req.page + "&perPage=" + req.perPage + "&activeSort=" + req.activeSort + "&sortDirection=" + req.sortDirection + "&filter=" + req.filter + "&trash=" + req.trash;
        return this.http.get(requestUrl).map( (res: any) => {
            return res;
        });
    }

    add(payment){
        let requestUrl = environment.apiUrl + 'external-company/payments/store';
        return this.http.post(requestUrl, payment).map( (res: any) => {
            return res;
        });
    }

    edit(payment){
        let requestUrl = environment.apiUrl + 'external-company/payments/update/' + payment.id;
        return this.http.put(requestUrl, payment).map( (res: any) => {
            return res;
        });
    }

    get(id){
        let requestUrl = environment.apiUrl + 'external-company/payments/get/' + id;
        return this.http.get(requestUrl).map( (res: any) => {
            return res;
        });
    }

    delete(id){
        let requestUrl = environment.apiUrl + 'external-company/payments/delete/' + id;
        return this.http.get(requestUrl).map( (res: any) => {
            return res;
        });
    }

}



// WEBPACK FOOTER //
// /Users/cricketmon/Sites/clubsandwichadmin/src/app/shared/services/external.company.payment.service.ts